import styled, { DefaultTheme } from 'styled-components';

export const Container = styled.div``;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const RichTextInput = styled.div`
  box-sizing: border-box;
  width: 100%;

  border: none;
  background: transparent;
  outline: none;

  white-space: pre-wrap;
  word-wrap: break-word;
`;

export const Placeholder = styled.span`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  opacity: 0.3;
  pointer-events: none;
`;

export const AutocompleteContainer = styled.div`
  max-height: 22rem;
  overflow-y: auto;
`;

export const getStyles = (theme: DefaultTheme) => ({
  goalSpanInInput: {
    backgroundColor: theme.palette.grey['100'],
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}`,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  },
  tagSpanInInput: {
    backgroundColor: theme.palette.grey['100'],
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}`,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  },
  personSpanInInput: {
    backgroundColor: '#94C7FF33',
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}`,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  },
  dateSpanInInput: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}`,
    cursor: 'pointer',
  },
  deadlineSpanInInput: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}`,
    cursor: 'pointer',
  },
  startTimeSpanInInput: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}`,
    cursor: 'pointer',
  },
  durationSpanInInput: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}`,
    cursor: 'pointer',
  },
  reminderSpanInInput: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}`,
    cursor: 'pointer',
  },
  rruleSpanInInput: {
    backgroundColor: '#40CA0033',
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}`,
    cursor: 'pointer',
  },
  targetSpanInInput: {
    backgroundColor: '#40CA0033',
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}`,
    cursor: 'pointer',
  },
  prioritySpanInInputHigh: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}`,
    cursor: 'pointer',
  },
  prioritySpanInInputMedium: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}`,
    cursor: 'pointer',
  },
  prioritySpanInInputLow: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}`,
    cursor: 'pointer',
  },
});

export type Styles = ReturnType<typeof getStyles>;
